module.exports = __webpack_public_path__ + "img/draw-polygon.1fb71b2a.svg";